import React from 'react';

import { MenuItem } from '@mui/material';
import { CheckMarkIcon } from 'src/components/icons/CheckMarkIcon';
import { IconColors } from 'src/components/icons/icon-utils';
import tinycolor from 'tinycolor2';
import { makeStyles } from 'tss-react/mui';

import type { ColorSelectFunction } from './ColorSelectComponent';

type MenuColorStyles = {
  backgroundColor: string;
};

const colorBorderColor = 'hsl(0, 0%, 50%)';

const useStyles = makeStyles<MenuColorStyles>()((_theme, { backgroundColor }) => ({
  colorItem: {
    '&:hover': {
      backgroundColor,
      border: `2px solid ${colorBorderColor}`,
    },
    alignItems: 'center',
    backgroundColor,
    border: `1px solid ${colorBorderColor}`,
    borderRadius: '50%',
    display: 'flex',
    height: 20,
    justifyContent: 'center',
    margin: 2,
    minHeight: 'unset',
    minWidth: 'unset',
    padding: 0,
    width: 20,
  },
}));

interface ColorSelectMenuColorProps {
  color: string;
  selectColor: ColorSelectFunction;
  selectedColor: string | null;
}

export function ColorSelectMenuColor({
  color,
  selectColor,
  selectedColor,
}: ColorSelectMenuColorProps): JSX.Element {
  const tinyColor = tinycolor(color);
  const isSelected = color === selectedColor;
  const { classes } = useStyles({ backgroundColor: color });

  return (
    <MenuItem
      key={color}
      dense
      className={classes.colorItem}
      onClick={(event: React.MouseEvent): void => selectColor(event, color)}
    >
      {isSelected && (
        <CheckMarkIcon fill={tinyColor.isDark() ? IconColors.White : IconColors.DarkGrey} />
      )}
    </MenuItem>
  );
}
